import React from "react";

import Button from "../shared/Button";
import Folder from "./Folder";

const Index = props => (
  <div style={{ paddingBottom: "120px" }}>
    {props.folders.allIds.map(id => (
      <Folder
        lng={props.lng}
        key={`ai-${id}`}
        userFullname={props.userFullname}
        userCompany={props.userCompany}
        clearModelExport={props.clearModelExport}
        handleDeleteModel={props.deleteModel}
        handleDeleteFolder={props.deleteFolder}
        openDownloadFolderModal={props.openDownloadFolderModal}
        openDeleteModelConfirmationModal={
          props.openDeleteModelConfirmationModal
        }
        openShareModelModal={props.openShareModelModal}
        openUpdateFolderModal={props.openUpdateFolderModal}
        models={props.modelsByFolderId[id] || []}
        {...props.folders.byIds[id]}
      />
    ))}

    <div className="folder__add" onClick={props.openCreateFolderModal}>
      <Button
        additionalClassName="button--icon folder__add-buton"
        icon="i-icon-plus"
      />
      <span className="pl2 f4">{props.t("footer:newProjectLabel")}</span>
    </div>
  </div>
);

export default Index;



// WEBPACK FOOTER //
// ./src/components/account/Index.js